import { getApplicationCode, getApplicationsFromSession } from './permisos'

const isActive = (access) => access?.active !== false && access?.application?.active !== false
const normalizeCode = (code) => String(code || '').toUpperCase()

// Other applications belong to the suite, not to this app's React router.
export const getSuiteUrl = (session) => {
  const home = getApplicationsFromSession(session).find((access) => (
    isActive(access) && normalizeCode(getApplicationCode(access)) === 'SUITE_HOME'
  ))
  const application = home?.application || home
  const candidate = application?.url || process.env.REACT_APP_SUITE_HOME_URL || 'https://suite.clasol.com'
  try {
    const url = new URL(candidate)
    if (['https:', 'http:'].includes(url.protocol)) return url.href
  } catch { /* Use the suite's public entry point if configuration is invalid. */ }
  return 'https://suite.clasol.com/'
}

export const getSidebarApplications = (session) => {
  const suiteUrl = getSuiteUrl(session)
  return getApplicationsFromSession(session)
    .filter(isActive)
    .filter((access) => !['SUITE_HOME', 'SUITE_ADMIN'].includes(normalizeCode(getApplicationCode(access))))
    .map((access) => {
      const application = access.application || access
      const code = normalizeCode(getApplicationCode(access))
      if (!code) return null
      if (code === 'QUALITY_PRODUCTION') return null // Local quality links have their own permissions.
      let url
      try {
        url = new URL(application.url || application.basePath || application.path || '/aplicaciones', suiteUrl)
        if (!['https:', 'http:'].includes(url.protocol)) return null
      } catch { return null }
      return {
        code,
        label: application.name || application.title || code,
        path: url.href,
        external: true,
        displayOrder: application.displayOrder ?? application.display_order ?? 0,
        icon: application.icon,
      }
    })
    .filter(Boolean)
    .sort((a, b) => a.displayOrder - b.displayOrder)
}
